module.exports = __webpack_public_path__ + "media/personas/bg-essentials-b09e4746.jpg";